export const coordenador = {
  nome: 'Gerente/Coordenador(a)',
  id_perfil: 7,
  dashboard: [
    {
      link: '/administracao',
      titulo: 'Administração',
      icone: 'icofont-tools',
      key: 'administracao',
    },
    {
      link: '',
      titulo: 'Pódio e equipes por classificação',
      icone: false,
      imagem: '',
      svg: '',
      key: 'modal_ranking_indicadores_aps',
      type: 'modal',
    },
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'VinculoAcompanhamento',
      key: 'vinculo_acompanhamento',
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/visitas-domiciliares',
      titulo: 'Visitas domiciliares',
      icone: false,
      imagem: '',
      svg: 'VisitasDomiciliares',
      key: 'visitas_domiciliares',
    },
    {
      link: '/atendimentos-no-mes',
      titulo: 'Relatório atendimentos',
      icone: 'icofont-list',
      key: 'atendimentos_no_mes',
    },
    {
      link: '/ultimas-visualizacoes',
      titulo: 'Últimas visualizações',
      icone: 'icofont-eye-alt',
      key: 'ultimas_visualizacoes',
    },
    {
      link: '/envio-app',
      titulo: 'Envio APP ACS PEC',
      icone: false,
      imagem: '',
      svg: 'EnvioApp',
      key: 'envio_app_acs_pec',
    },
    {
      link: '/imunizacao',
      titulo: 'Imunização',
      icone: false,
      imagem: require('@/assets/icones/imunizacao.png'),
      key: 'imunizacao',
    },
    // {
    //   link: '/informatiza-aps',
    //   titulo: 'Informatiza APS',
    //   icone: false,
    //   imagem: '',
    //   svg: 'InformatizaAps',
    //   key: 'informatiza_aps',
    // },
    {
      link: '/profissionais-pec-cnes',
      titulo: 'Profissionais PEC CNES',
      icone: false,
      imagem: '',
      svg: 'ProfissionaisPecCnes',
      key: 'profissionais_pec_cnes',
    },
    // {
    //   link: '/saude-crianca',
    //   titulo: 'Saúde criança',
    //   icone: false,
    //   imagem: '',
    //   svg: 'SaudeCrianca',
    //   key: 'saude_crianca',
    // },
    {
      link: '/risco-cardiovascular/equipe/acs',
      titulo: 'Risco Cardiovascular',
      icone: 'icofont-heart-beat-alt',
      key: 'risco_cardiovascular',
    },
    {
      link: '/producao',
      titulo: 'Produção',
      icone: 'icofont-list',
      key: 'producao',
    },
    {
      link: '/aedes-aegypti/equipe/acs',
      titulo: 'Aedes aegypti',
      icone: false,
      imagem: '',
      svg: 'AedesAegypti',
      key: 'aedes_aegypti',
    },
    // {
    //   link: '/pos-covid-19/equipe/acs',
    //   titulo: 'Pós Covid-19',
    //   icone: false,
    //   imagem: '',
    //   svg: 'PosCovid19',
    //   key: 'pos_covid_19',
    // },
    {
      link: '/bpa-e-ras',
      titulo: 'BPA E RAS',
      icone: 'icofont-copy-invert',
      key: 'bpa_e_ras',
    },
    {
      link: '/tria/equipe/acs',
      titulo: 'TRIA',
      icone: 'icofont-culinary',
      key: 'tria',
    },
    {
      link: '/ceo',
      titulo: 'CEO',
      icone: 'icofont-tooth',
      key: 'ceo',
    },
    {
      link: '/iaf',
      titulo: 'IAF',
      icone: false,
      imagem: '',
      svg: 'Iaf',
      key: 'incentivo_atividade_fisica',
    },
    {
      link: '/pse',
      titulo: 'PSE',
      icone: false,
      imagem: require('@/assets/icones/pse.png'),
      key: 'pse',
    },
    {
      link: '/oficinas-treinamentos',
      titulo: 'Oficinas Reuniões Treinamentos',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos',
      featured: true,
    },
    {
      link: '/upa',
      titulo: 'UPA',
      icone: 'icofont-hospital',
      key: 'upa',
    },
  ],
  administracao: [
    {
      link: '/profissionais-lotacoes',
      titulo: 'Profissionais e Lotações',
      icone: 'icofont-people',
      key: 'profissionais_lotacoes',
    },
    {
      link: '/escolas',
      titulo: 'Escolas',
      icone: 'icofont-university',
      key: 'administracao_escolas',
    },
  ],
  gestao_cadastros: [
    {
      link: '/cidadao/painel',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
      // openNewTab: true,
      // callback: function (ctx, navigate) {
      //   const parceiro = ctx.$store.state?.infoMunicipio?.parceiro
      //   if (parceiro == null) {
      //     navigate(this.link, this.openNewTab)
      //   } else {
      //     ctx.$toast.error('Não disponível.', '', { position: 'topRight' })
      //   }
      // },
    },
    {
      link: '/busca-ativa-cadastro',
      titulo: 'Busca Ativa Cadastro',
      icone: 'icofont-people',
      key: 'cidadaos_sem_equipe',
    },
    {
      link: '/cidadaos-duplicados',
      titulo: 'Cidadãos duplicados',
      icone: 'icofont-copy-invert',
      key: 'cidadaos_duplicados',
    },
    // {
    //   link: '/cidadaos-sem-acs',
    //   titulo: 'Cidadãos sem ACS',
    //   icone: 'icofont-users-alt-4',
    //   key: 'cidadaos_sem_acs',
    // },
    {
      link: '/cadastros-sem-cpf',
      titulo: 'Cadastros sem CPF',
      icone: 'icofont-copy-invert',
      key: 'cadastros_sem_cpf',
    },
    {
      link: '/calculadora-de-pessoas',
      titulo: 'Calculadora de pessoas',
      icone: 'icofont-ui-calculator',
      key: 'calculadora_de_pessoas',
    },
    {
      link: '/obitos/equipe/acs',
      titulo: 'Óbitos',
      icone: 'icofont-list',
      key: 'obitos',
    },
    // {
    //   link: '/mudanca_territorio/equipe/acs',
    //   titulo: 'Mudança de Território',
    //   icone: 'icofont-list',
    //   key: 'mudanca_territorio',
    // },
  ],
  visitas_domiciliares: [
    {
      link: '/cidadaos-visitados',
      titulo: 'Cidadãos visitados',
      icone: false,
      imagem: '',
      svg: 'CidadaosVisitados',
      key: 'cidadaos_visitados',
    },
    {
      link: '/familias-visitadas',
      titulo: 'Famílias visitadas',
      icone: false,
      imagem: '',
      svg: 'FamiliasVisitadas',
      key: 'familias_visitadas',
    },
    {
      link: '/desempenho-por-microarea',
      titulo: 'Desempenho por microárea',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorAcs',
      key: 'desempenho_por_acs',
    },
  ],
  imunizacao: [
    {
      link: '/importar-vacinas',
      titulo: 'Importar vacinas',
      icone: false,
      imagem: '',
      svg: 'ImportarVacinas',
      key: 'imunizacao_importar_vacinas',
    },
    {
      link: '/vacina-idade-certa',
      titulo: 'Vacina idade certa',
      icone: false,
      imagem: require('@/assets/icones/situacao_vacinal.png'),
      key: 'vacina_idade_certa',
    },
    {
      link: '/campanha-gripe',
      titulo: 'Campanha gripe',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/campanha-gripe.png'),
      key: 'campanha_gripe',
    },
    {
      link: '/divergencias-vacinas',
      titulo: 'Divergências vacinas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/inconsistencias.png'),
      key: 'divergencia_vacinas',
    },
    {
      link: '/dose-imunizante',
      titulo: 'Dose Imunizante',
      icone: 'icofont-injection-syringe',
      key: 'dose_imunizante',
    },
  ],
  vacina_idade_certa: [
    {
      link: '/faltosos-vacinas-0-15-anos',
      titulo: '0 - 15 anos',
      icone: false,
      imagem: require('@/assets/icones/2anos.png'),
      key: 'faltosos_2_anos',
    },
    {
      link: '/hpv-quadrivalente',
      titulo: 'HPV quadrivalente',
      icone: false,
      imagem: require('@/assets/icones/hpv.png'),
      key: 'hpv_quadrivalente',
    },
    {
      link: '/acwy',
      titulo: 'Meningocócica ACWY',
      icone: false,
      imagem: require('@/assets/icones/acwy.png'),
      key: 'meningococica_acwy',
    },
    {
      link: '/covid19-infantil',
      titulo: 'COVID-19 Infantil',
      icone: false,
      imagem: '',
      svg: 'Covid19Infantil',
      key: 'covid19_infantil',
    },
    {
      link: '/criancas-dtp-em-atraso',
      titulo: 'DTP',
      iicone: false,
      imagem: '',
      svg: 'Dtp',
      key: 'criancas_dtp_em_atraso',
    },
    {
      link: '/pneumococica-10v',
      titulo: 'Pneumocócica 10V (conjugada)',
      icone: false,
      imagem: '',
      svg: 'Pneumo',
      key: 'pneumococica_10V',
    },
    {
      link: '/triplice-viral',
      titulo: 'Tríplice viral',
      icone: false,
      imagem: '',
      svg: 'TripleceViral',
      key: 'triplice_viral',
    },
    {
      link: '/varicela',
      titulo: 'Varicela',
      icone: false,
      imagem: '',
      svg: 'Varicela',
      key: 'varicela',
    },
    {
      link: '/tetra-viral',
      titulo: 'Tetra viral',
      icone: 'icofont-injection-syringe',
      key: 'tetra_viral',
    },
    {
      link: '/vacina-dengue',
      titulo: 'Vacina Dengue',
      icone: 'icofont-injection-syringe',
      key: 'vacina_dengue',
    },
  ],
  divergencia_vacinas: [
    {
      link: '/divergencias-vacinas/vacinas-nao-enviadas',
      titulo: 'Vacinas não enviadas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_nao_enviadas.png'),
      key: 'vacinas_nao_enviadas',
    },
    {
      link: '/divergencias-vacinas/d3-antes-6',
      titulo: 'D3 antes 6 meses',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/D3.png'),
      key: 'd3_antes_6_meses',
    },
    {
      link: '/divergencias-vacinas/vacinas-nascimento-divergente',
      titulo: 'Vacinas nascimento divergente',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_nascimento_divergente',
    },
    {
      link: '/divergencias-vacinas/vacinas-sem-cadastro',
      titulo: 'Vacinas sem cadastro',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_sem_cadastro.png'),
      key: 'vacinas_sem_cadastro',
    },
    {
      link: '/divergencias-vacinas/vacinas-antes-nascimento',
      titulo: 'Vacinas antes nascimento',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_antes_nascimento',
    },
  ],
  indicadores_aps: [
    {
      link: '/esf-eap',
      titulo: 'eSF / eAP',
      icone: false,
      imagem: '',
      svg: 'eSFeAP',
      key: 'esf_eap',
    },
    {
      link: '/emulti',
      titulo: 'eMulti',
      icone: false,
      imagem: '',
      svg: 'eMulti',
      key: 'emulti',
    },
    {
      link: '/saude-bucal',
      titulo: 'eSB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal',
    },
    {
      link: '/indicadores-aps/resultado-municipal',
      titulo: 'Resultado Municipal',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'resultado_municipal_indicadores_aps',
    },
    // {
    //   link: '/resultado-isf-acs',
    //   titulo: 'Resultado ISF',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ResultadoIsf',
    //   key: 'resultado_isf',
    // },
    // {
    //   link: '/resultado-indicadores',
    //   titulo: 'Resultado Indicadores',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ResultadoIndicadores',
    //   key: 'resultado_indicadores',
    // },
    // {
    //   link: '/desempenho-por-equipe',
    //   titulo: 'Desempenho por Equipe',
    //   icone: false,
    //   imagem: '',
    //   svg: 'DesempenhoPorEquipe',
    //   key: 'desempenho_por_equipe',
    // },
  ],
  pre_natal: [
    // {
    //   link: '/consultas-pre-natal/equipe/acs',
    //   titulo: 'Consultas pré-natal',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ConsultasPreNatal',
    //   key: 'consultas_pre_natal',
    // },
    // {
    //   link: '/problemas-ativos/equipe',
    //   titulo: 'Problemas ativos',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ProblemasAtivos',
    //   key: 'problemas_ativos',
    // },
    // {
    //   link: '/consultas-odontologicas/equipe/acs',
    //   titulo: 'Consultas odontológicas',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ConsultasOdontologicas',
    //   key: 'consultas_odontologicas',
    // },
    // {
    //   link: '/exames-hiv-sifilis/equipe/acs',
    //   titulo: 'Exames HIV e Sífilis',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ExamesHivSifilis',
    //   key: 'hiv_sifilis',
    // },
    // {
    //   link: '/tres-indicadores-pre-natal/equipe/acs',
    //   titulo: 'Os 3 Indicadores Pré-natal',
    //   icone: false,
    //   imagem: '',
    //   svg: 'TresIndicadoresPreNatal',
    //   key: 'tres_indicadores_pre_natal',
    // },
  ],
  doencas_cronicas: [
    // {
    //   link: '/hemoglobina-glicada/equipe/acs',
    //   titulo: 'Atendimento diabetes',
    //   icone: false,
    //   imagem: '',
    //   svg: 'AtendimentosDiabetes',
    //   key: 'atendimento_diabetes',
    // },
    // {
    //   link: '/atendimento-hipertensao/equipe/acs',
    //   titulo: 'Atendimento Hipertensão',
    //   icone: false,
    //   imagem: '',
    //   svg: 'AtendimentoHipertensao',
    //   key: 'atendimento_hipertensao',
    // },
    // {
    //   link: '/hiper-dia/equipe/acs',
    //   titulo: 'Atendimento HiperDia',
    //   icone: false,
    //   imagem: '',
    //   svg: 'HiperDia',
    //   key: 'atendimento_hiper_dia',
    // },
  ],
  desempenho_por_equipe: [
    // {
    //   link: '/desempenho-por-equipe/indicador',
    //   titulo: 'Desempenho por Indicador',
    //   icone: 'icofont-brand-designbump',
    //   key: 'desempenho_por_indicador',
    // },
    // {
    //   link: '/desempenho-por-equipe/geral',
    //   titulo: 'Desempenho Geral',
    //   icone: 'icofont-brand-designbump',
    //   key: 'desempenho_geral',
    // },
  ],
  saude_crianca: [
    // {
    //   link: '/teste-pezinho',
    //   titulo: 'Teste do pezinho',
    //   icone: 'icofont-foot-print',
    //   key: 'teste_pezinho',
    // },
  ],
  producao: [
    {
      link: '/procedimentos',
      titulo: 'Procedimentos',
      icone: 'icofont-list',
      key: 'procedimentos',
    },
  ],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Resultado Municipal',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/equipe/acs',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/avaliacao-atendimentos',
      titulo: 'Avaliação do atendimento',
      icone: 'icofont-heart-eyes',
      key: 'avaliacao_atendimentos',
    },
    {
      link: '/condicoes-saude',
      titulo: 'Condições Saúde',
      key: 'comorbidades',
      icone: false,
      imagem: require('@/assets/icones/comorbidades.png'),
    },
    {
      link: '/agenda-por-profissional/equipe/acs',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'vinculo_acompanhamento_atendimentos_pessoa',
    },
  ],
  bpa_e_ras: [
    {
      link: '/exportar-bpa',
      titulo: 'Exportar BPA',
      icone: 'icofont-copy-invert',
      key: 'exportar_bpa',
      featured: true,
    },
    {
      link: '/bpa-c',
      titulo: 'BPA C',
      icone: 'icofont-copy-invert',
      key: 'bpa_c',
    },
    {
      link: '/bpa-i',
      titulo: 'BPA I',
      icone: 'icofont-copy-invert',
      key: 'bpa_i',
    },
    // {
    //   link: '/ras',
    //   titulo: 'RAS',
    //   icone: 'icofont-copy-invert',
    //   key: 'ras',
    // },
  ],
  saude_bucal: [
    {
      link: '/primeira-consulta-programada',
      titulo: 'Primeira consulta',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/procedimentos-odonto-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-atramautico',
      titulo: 'Tratamento Atraumático',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/saude-bucal-gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'ConsultasPreNatal',
      key: 'saude_bucal_gestantes',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
  ],
  esf_eap: [
    // {
    //   link: '/busca-ativa/equipe/acs',
    //   titulo: 'Busca Ativa',
    //   icone: 'icofont-search-user',
    //   key: 'busca_ativa',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/mais-acesso-aps',
      titulo: 'Mais acesso',
      icone: false,
      imagem: '',
      svg: 'MaisAcessoAps',
      key: 'mais_acesso_aps',
    },
    // {
    //   link: '/indicador-citologico/equipe/acs',
    //   titulo: 'Exames Citopatológico',
    //   icone: 'icofont-stretcher',
    //   key: 'citopatologico',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    // {
    //   link: '/indicador-imunizacao/equipe/acs',
    //   titulo: 'Desenvolvimento infantil',
    //   icone: 'icofont-baby',
    //   key: 'vacinas_polio_penta',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/desenvolvimento-infantil',
      titulo: 'Desenvolvimento infantil',
      icone: false,
      imagem: '',
      svg: 'DesenvolvimentoInfantil',
      key: 'desenvolvimento_infantil',
    },
    {
      link: '/gestantes-puerperas',
      titulo: 'Gestantes puérperas',
      icone: false,
      imagem: '',
      svg: 'GestantesPuerperas',
      key: 'gestantes_puerperas',
    },
    // {
    //   link: '/pre-natal',
    //   titulo: 'Gestantes e Puérperas',
    //   icone: false,
    //   imagem: require('@/assets/images/pregnant.png'),
    //   key: 'pre_natal',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    // {
    //   link: '/doencas-cronicas',
    //   titulo: 'Doenças crônicas',
    //   icone: 'icofont-drug',
    //   key: 'doencas_cronicas',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/pessoa-diabetes',
      titulo: 'Pessoa diabética',
      icone: false,
      imagem: '',
      svg: 'PessoaDiabetes',
      key: 'pessoa_diabetes',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-hipertensao',
      titulo: 'Pessoa hipertensa',
      icone: false,
      imagem: '',
      svg: 'PessoaHipertensao',
      key: 'pessoa_hipertensao',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-idosa',
      titulo: 'Pessoa idosa',
      icone: false,
      imagem: '',
      svg: 'PessoaIdosa',
      key: 'pessoa_idosa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/saude-da-mulher',
      titulo: 'Saúde mulher',
      icone: false,
      imagem: '',
      svg: 'SaudeDaMulher',
      key: 'saude_da_mulher',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
  ],
  emulti: [
    {
      link: '/media-atendimentos-por-pessoa',
      titulo: 'Pessoas atendidas',
      icone: false,
      imagem: '',
      svg: 'PessoasAtendidas',
      key: 'media_atendimentos_por_pessoa_emulti',
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: false,
      imagem: '',
      svg: 'AcoesInterprofissionais',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
  ],
  oficinas_treinamentos: [
    {
      link: '/oficinas-treinamentos-facilitador',
      titulo: 'Facilitador',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos_facilitador',
    },
    {
      link: '/oficinas-treinamentos-participante',
      titulo: 'Participante',
      icone: 'icofont-user',
      key: 'oficinas_treinamentos_participante',
    },
    {
      link: '/oficinas-treinamentos-certificados',
      titulo: 'Meus Certificados',
      icone: 'icofont-certificate',
      key: 'oficinas_treinamentos_certificados',
    },
    {
      link: '/avaliacao-treinamento/analise',
      titulo: 'Avaliações Sugestões',
      icone: 'icofont-list',
      key: 'avaliacao_treinamento',
    },
    {
      link: '/ficha-atividade-coletiva',
      titulo: 'Criar ficha de atividade coletiva',
      icone: 'icofont-list',
      key: 'ficha_atividade_coletiva',
    },
  ],
  upa: [
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'upa_atendimentos_pessoa',
    },
    {
      link: '/atendimentos-classificacao',
      titulo: 'Atendimentos classificação',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_classificacao',
    },
  ],
}
